export default __webpack_public_path__ + "static/media/link_icon.e60f2792.svg";